import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export const defaultFieldSubEntities = [
  ContactSlugEnum.FirstName,
  ContactSlugEnum.Surname,
  ContactSlugEnum.Email,
]
